import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from '../Common/SelectCommonDefault';

class Limites extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            factorLimiteCompra: "",
            limiteCompra: ""
        };
    }

    handleChangeFactorLimite(e) {
        //LA CONDICIÓN DEBE CONSIDERAR QUE SE TRATE DE UN STRING CON "." COMO ÚLTIMO ÍNDICE PARA QUE PERMITA ESCRIBIR NUMEROS CON DECIMALES
        if(/^[0-9]*$/.test(e.target.value)||/^[0-9]*$/.test(e.target.value.split(".")[0])){
        this.props.onBlurTextBox("factorLimiteCompra", e.target.value);
        }
    }

    handleChangeLimiteCompra(e) {
        if(/^[0-9]*$/.test(e.target.value)){
            this.props.onBlurTextBox("limiteCompra", e.target.value);
        }
    }

    componentDidUpdate() {

        let { data, radioMonedaSelected, onBlurTextBox, tarjetas } = this.props;

        //SI SE TRATA DE UNA MODIFICACIÓN, UNA VEZ CARGADOS TODOS LOS DATOS DE PRODUCTO SE PROCEDE A CARGAR LAS SELECCIONES DE LA SOLICITUD A MODIFICAR
        if(!data.isFetching &&  !this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID && tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.Id && tarjetas.esModificacion && !data.limitesModificacion){
            let limiteC = tarjetas.datosSolicitud.ImporteLimiteCompra;
            let flcc = tarjetas.datosSolicitud.FactorLimiteCompraCuotas ? tarjetas.datosSolicitud.FactorLimiteCompraCuotas : null;
            //SI EL LÍMITE DE COMPRA NO ES POR ID, ES POR MONTO, POR LO QUE SE DEBE CARGAR EL INPUT CON LA SELECCIÓN DE LA SOLICITUD A MODIFICAR
            if(!tarjetas.datosSolicitud.LimiteCompraId){

                let moneda = tarjetas.datosSolicitud.MonedaId == 1 ? "PESOS":"DOLARES"

                this.setState({ limiteCompra: limiteC });
                onBlurTextBox("limiteCompra", limiteC);
                radioMonedaSelected(moneda);
            }
            //SI HAY FLCC SE CARGA EL MISMO
            if(flcc){
                this.setState({ factorLimiteCompra: flcc });
                onBlurTextBox("factorLimiteCompra", flcc);
            }
            if(((!tarjetas.datosSolicitud.LimiteCompraId && data.limiteCompra == limiteC) || tarjetas.datosSolicitud.LimiteCompraId ) && ((flcc && data.factorLimiteCompra == flcc) || !flcc && limiteC)){
                this.props.cargarDatosModificacion("limitesModificacion")
            } 
        }

        if ((data.pesos || data.dolares) && !data.GET_PRODUCTO_VISA_PRODUCTO_ID)
            radioMonedaSelected(" ");

        if (data.limiteCompra && data.limiteCompra != this.state.limiteCompra) {
            this.setState({ limiteCompra: data.limiteCompra });
            onBlurTextBox("limiteCompra", data.limiteCompra);
        }

        if (data.factorLimiteCompra && data.factorLimiteCompra != this.state.factorLimiteCompra) {
            this.setState({ factorLimiteCompra: data.factorLimiteCompra });
            onBlurTextBox("factorLimiteCompra", data.factorLimiteCompra);
        }
    }

    render() {
        const { data, tarjetas, selectCombo, onBlurTextBox, radioMonedaSelected } = this.props;
        
        let funcionamientoLimites = data.GET_PRODUCTO_VISA_PRODUCTO_ID ? (data.GET_PRODUCTO_VISA_PRODUCTO_ID.TipoLimiteIndividuos == "LU" ? "Unificados(LU)" : "Otorgados") : "";
        let FLCCxCuenta = data.GET_PRODUCTO_VISA_PRODUCTO_ID ? data.GET_PRODUCTO_VISA_PRODUCTO_ID.FLCCxCuenta : null;
        let modalidadDistribucionLimiteList = data.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID ? data.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID.map((modalidad) => { return { Id: modalidad.Id, Descripcion: modalidad.DESCRIPCION } }) : [];
        let limiteCompraList = data.GET_LIMITE_COMPRA_PRODUCTO ? data.GET_LIMITE_COMPRA_PRODUCTO.map((limite) => { return { Id: limite.ID, Descripcion: (limite.CODIGO + ' - ' + (limite.MonedaId == "1" ? '$ ' : 'u$s ')   +  limite.VALOR.toString().split( /(?=(?:\d{3})+(?:\.|$))/g ).join( "." ))} }) : [];
        let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;
        let lineasPrestamo = data.GET_LINEA_PRESTAMO_PRODUCTO.map((lineaPrestamo) => { return {Id: lineaPrestamo.ID , Descripcion: (lineaPrestamo.CODIGO + " - " + lineaPrestamo.DESCRIPCION)} });
        let productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
        let valoresDefault = !tarjetas.esModificacion ? data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO : tarjetas.datosSolicitud;
        let errorFLCC 
        let limiteMaximo =""
        if( productoVisa && productoVisa.LimiteCompraMaximo){
            limiteMaximo = productoVisa.LimiteCompraMaximo && productoVisa.LimiteCompraMaximo.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        }
        if(data.factorLimiteCompra && productoVisa){
            errorFLCC = !(parseInt(data.factorLimiteCompra) >= parseInt(productoVisa.FLCCDesde) && parseInt(data.factorLimiteCompra) <= parseInt(productoVisa.FLCCHasta))
        }
        let errorLimite 
        if(data.limiteCompra && productoVisa){
            errorLimite = !(parseInt(data.limiteCompra) <= parseInt(productoVisa.LimiteCompraMaximo))
        }
        
        if(!data.pesos && !data.dolares && parametrosGenerales && productoVisa){
            let monedaDefaultLimiteCompra = parametrosGenerales.MONEDALIMITECOMPRA == "D" ? "DOLARES" : "PESOS";
            radioMonedaSelected(monedaDefaultLimiteCompra);
        }
        
        return (
            <div className="row">
                <div className="col-md-12">
                   <div className="row">
                        <div className="correspondencia-contacto-cliente col-md-12">
                            <div className="divisor-section bottom-separator" >
                                <h2>Límites</h2>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className="label-primary">Funcionamiento de Límites</label>
                            <div className="form-group bottom-separator-xs">
                                <div className="funcionamiento-limites"> {funcionamientoLimites}</div>
                            </div>              
                        </div>
                        <div className="col-md-12 bottom-separator-xs">
                            <div className="form-group  datos-generales-cuenta">
                                <label className="label-primary">Modelo de Distribución de Límites</label>
                                <SelectCommonDefault esModificacion={tarjetas.esModificacion} infoData={modalidadDistribucionLimiteList} valorCombo={valoresDefault["DistribucionLimiteDefaultId"] ? valoresDefault["DistribucionLimiteDefaultId"] : valoresDefault["ModalidadDistribucionLimiteId"]} selectCombo={selectCombo} nombreAction={"modeloDistribucionId"} selecciones={data}/>

                                {(!data.ERROR_CUENTA["modeloDistribucionId"])
                                    && <label className="error">{"Debe seleccionar una modalidad de distribución de límites."}</label>}

                            </div>
                        </div>
                        {productoVisa && !productoVisa.LimiteCompraMaximo ? 
                            (<div className="col-md-12 bottom-separator-xs">
                                <label className="label-primary">Límite de Compra</label>
                                <SelectCommonDefault esModificacion={tarjetas.esModificacion} infoData={limiteCompraList} valorCombo={valoresDefault["LimiteCompraDefaultId"] ? valoresDefault["LimiteCompraDefaultId"] : valoresDefault["LimiteCompraId"]} selectCombo={selectCombo} nombreAction={"limiteCompraId"} selecciones={data}/>
                                {(!data.ERROR_CUENTA["limiteCompraId"]) && <label className="error">{"Debe seleccionar un limite de compra."}</label>}
                            
                            </div>) 
                        : (<div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="funcionamiento-limites-input"> Límite de Compra </label>
                                        <input placeholder="Ingrese Monto..." type="text" maxLength="8" className="input-separate inputAlta" value={tarjetas.solicitudCuenta.limiteCompra == "0" ? null : tarjetas.solicitudCuenta.limiteCompra} onChange={this.handleChangeLimiteCompra.bind(this)} />
                                        {productoVisa ? (<label className="funcionamiento-limites-input"> (Monto Máximo ${limiteMaximo})</label>) : null}
                                    </div>
                                    <div className="col-md-12">
                                        {(!data.ERROR_CUENTA["limiteCompra"] && errorLimite)
                                            && <label className="error">{"Debe ingresar un limite de compra inferior al máximo definido por el producto."}</label>}
                                        {(!data.ERROR_CUENTA["limiteCompra"] && !errorLimite)
                                            && <label className="error">{"Debe ingresar un limite de compra superior a cero."}</label>}
                                    </div>
                                </div>
                            </div>)}
                            {productoVisa && productoVisa.LimiteCompraMaximo && <div className= "col-md-12 bottom-separator-xs">
                                <div className="row row-radio">
                                    <div className="col-xs-12">
                                        <div className="container-radio radio-margin">
                                            <input id="monedaCuenta" type="radio" name="group12" checked={data.pesos} />
                                            <label className="lbl-radio label-secondary check-radio-new" onClick={() => radioMonedaSelected("PESOS")} >
                                                Pesos
                                                </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-radio">
                                    <div className="col-xs-12">
                                        <div className="container-radio radio-margin">
                                            <input id="monedaCuenta" type="radio" name="group12" checked={data.dolares} />
                                            <label className="lbl-radio label-secondary check-radio-new" onClick={() => radioMonedaSelected("DOLARES")} >
                                                Dolares
                                                </label>
                                        </div>
                                    </div>
                                </div>

                                {(!data.ERROR_CUENTA["monedaSelected"])
                                    && <label className="error">{"Debe seleccionar una moneda."}</label>}
                            </div>}
                   </div>

                   {FLCCxCuenta && parametrosGenerales.SINOFACTORLIMITECOMPRACUOTA ? (
                        <div>
                            <div className="row">
                               <div className="col-md-12">
                                   <label className="label-primary">FLCC Factor Límite de Compra en Cuotas</label>
                               </div>
                            </div>
                           <div className="row bottom-separator-xs">
                               <div className="col-md-12">
                                   <label className="funcionamiento-limites-input">Factor</label>
                                   <input type="text" maxLength="5" className="input-separate-short inputAlta" value={tarjetas.solicitudCuenta.factorLimiteCompra} onChange={this.handleChangeFactorLimite.bind(this)}/>
                                   <label className="funcionamiento-limites-input"> (entre {productoVisa.FLCCDesde} y {productoVisa.FLCCHasta})</label>

                               </div>
                               <div className="col-md-12">
                                   {(!data.ERROR_CUENTA["factorLimiteCompra"] && errorFLCC)
                                       && <label className="error">{" El Factor de Limite de Compra en Cuotas debe estar dentro del rango definido por el producto."}</label>}
                                    {(!data.ERROR_CUENTA["factorLimiteCompra"] && !errorFLCC)
                                       && <label className="error">{"Debe ingresar un factor límite de compra en cuotas."}</label>}
                               </div>
                           </div>
                       </div>) : null}

                   {(parametrosGenerales.SINOLINEAPRESTAMOS && lineasPrestamo && lineasPrestamo.length>0) ?
                       (<div className="row">
                           <div className="col-md-12">
                               <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                   <label className="label-primary">Límite de Préstamos</label>
                                   <SelectCommonDefault infoData={lineasPrestamo} valorCombo={valoresDefault["LimitePrestamoDefaultId"] ? valoresDefault["LimitePrestamoDefaultId"] : valoresDefault["LineaPrestamoId"]} selectCombo={selectCombo} nombreAction={"limitePrestamoId"} selecciones={data}/>
                               </div>
                           </div>
                       </div>) : null}
                </div>
           </div>
       )
    }
}

export default Limites;